export default {
  common: {
    label: {
      identityCard: '身份证',
      identityCardFront: '证件人像面',
      identityCardBack: '证件国徽面',
      identityCardHold: '手持身份证照片',
      passport: '护照',
      driverLicense: '驾驶证',
      other: '其他',
      upload: '上传'
    },
    content: {
      identityCardFront: '身份证人像面（照片、文字清晰且边框完整）',
      identityCardBack: '身份证国徽面（文字清晰且边框完整）',
      identityCardHold: '上传手持身份证人像面照片（建议使用手机后置摄像头进行拍摄，需照片清晰，证件字迹清晰可辨认）',
      passport: '上传护照',
      passportHold: '上传手持护照首页照片（建议使用手机后置摄像头进行拍摄，需照片清晰，证件字迹清晰可辨认）',
      identityCardHint: "需上传身份证正反面照片或扫描件，滑动鼠标至上传框可查看示例",
      identityCardHintP: "需上传身份证正反面照片或扫描件，以及手持身份证且五官及身份证清晰的照片，滑动鼠标至上传框可查看示例",
      passportHint: "需上传护照信息页扫描件，以及手持护照且五官及护照清晰的照片，滑动鼠标至上传框可查看示例。",
      
    },
    placeholder: {
      identityCardFront: '请上传证件正面',
      identityCardBack: '请上传证件反面',
      identityCardHold: '请上传手持身份证照片',
      passport: '需上传护照信息页扫描件，以及手持护照且五官及护照清晰的照片，滑动鼠标至上传框可查看示例。',
      driverLicense: '请上传驾驶证',
      other: '请上传其他证件'
    },
    validate: {
      passport: "请上传证件正面",
      passportHold: "请上传手持护照首页照片",
       mobilePhone: "请输入正确的手机号",
      mobilePhoneCode: "请输入手机验证码",
      email: "请输入正确的邮箱",
      emailUniqueness: "该邮箱已被使用",
      emailCode: "请输入邮箱验证码",
      password: "请输入密码",
      passwordRule: "密码必须为6到16位的字母、数字的组合",
      confirmPassword: "请再次输入密码",
      passwordInconsistent: "密码不一致！",
      amount: "请输入金额",
      loginName: "请输入用户名",
      characterSet: "字符输入错误",
      characterLength: "字符长度不得超过{char}",
      idCard: "请输入正确的身份证号码"
    }
  },
  global: {
    content: { // global.content.text_1
      text_1: '寻汇Sunrate营销会员账户', // 寻汇Sunrate营销会员账户
      text_2: '操作成功',
      text_3: '上传成功',
      text_4: '上传失败',
      text_5: '修改成功',
      text_6: '添加成功',
      text_7: '尚未完成认证,请先进行认证',
      text_8: '上传',
      text_9: '查看',
      text_10: '重新上传',
      text_11: '复制',
      text_12: '复制成功',
      text_13: '无开始日期',
      text_14: '无结束日期',
      text_15: '《商业条款》 下载',
      text_16: '《寻汇营销会员合作协议》',
    },
    validate: { // global.validate.text_1
      mobilePhone: "请输入正确的手机号",
      mobilePhoneCode: "请输入手机验证码",
      email: "请输入正确的邮箱",
      emailUniqueness: "该邮箱已被使用",
      emailCode: "请输入邮箱验证码",
      password: "请输入密码",
      passwordRule: "密码必须为6到16位的字母、数字的组合",
      confirmPassword: "请再次输入密码",
      passwordInconsistent: "密码不一致！",
      amount: "请输入金额",
      loginName: "请输入用户名",
      characterSet: "字符输入错误",
      characterLength: "字符长度不得超过{char}",
      idCard: "请输入正确的身份证号码"
    },
    label: { // global.label.text_1
      email: "邮箱",
      emailCode: "邮箱验证码",
      cellphone: "手机号",
      cellphoneCode: "手机验证码",
      newPassword: "新密码",
      confirmPassword: "密码确认"
    },
    btn: {
      submit: "提交",
      cellphone: "通过邮箱找回",
      email: "通过手机找回"
    },
    dialog: {
      title: { // global.dialog.title.text_1
        text_1: '提示',
      },
      content: { // global.dialog.content.text_1
        text_1: '确认更改',
        text_2: '取消',
        text_3: '更改认证类型后，当前您已填写信息将会丢失，请谨慎操作',
      }
    },
    bindEmailDialog: {
      title: { // global.bindEmailDialog.title.text_1
        text_1: '绑定邮箱通知',
      },
      content: { // global.bindEmailDialog.content.text_1
        text_1: '当前账户手机号',
        text_2: '绑定邮箱地址',
        text_3: '邮箱验证码',
        text_4: '确认绑定',
        text_5: '邮箱验证码失效,请重新获取',
        text_6: '账户中心',
        text_7: '切换语言',
        text_8: '退出登录',
      },
    }
  },
  commonBtn: {
    btn: {
      submit: '提交',
      cancel: '取消',
    }
  },
  enum: { // enum.text_1
    text_1: '工作台', // Dashboard
    text_2: '客户列表', // Referral List
    text_3: '收款列表', // Collection List
    text_4: '支付列表', // Payment List
    text_5: '认证信息',
    text_6: '个人中心',
    text_7: '注册成功',
    text_8: '注册',
    text_9: '找回密码',
    text_10: '登录',
    text_11: '找不到页面',
    text_12: '没有权限',
    text_13: '结算管理',
    text_14: '代理商结算',
    text_15: '销售结算',
    text_16: '客户管理',
    text_17: '未开户客户列表',
    text_18: '已开户客户列表',
  },
  user: {
    register: {
      title: { // user.register.title.text_1
        text_1: '注册寻汇Sunrate营销会员账户', // 注册寻汇Sunrate营销会员账户
        text_2: '邮箱信息', // 邮箱信息
        text_3: '手机号信息', // 手机号信息
        text_4: '密码确认', // 密码确认
        text_5: '推荐人(选填)', // 推荐人(选填)
        text_6: '推荐码', // 推荐码
      },
      placeholder: { // user.register.placeholder.text_1
        text_1: '请输入邮箱', // 请输入邮箱
        text_2: '请输入邮箱验证码', // 请输入邮箱验证码
        text_3: '请输入手机号', // 请输入手机号
        text_4: '请输入密码', // 请输入密码
        text_5: '请再次输入密码', // 请再次输入密码
        text_6: '可选填', // 可选填
      },
      error: { // user.register.error.text_1
        text_1: '请输入正确的邮箱', // 请输入正确的邮箱
        text_2: '请输入邮箱验证码', // 请输入邮箱验证码
        text_3: '请输入正确的手机号', // 请输入正确的手机号
        text_4: '请输入手机号验证码', // 请输入手机号验证码
        text_5: '请先阅读并同意《寻汇营销会员合作协议》与《Sunrate隐私政策》', // 请先阅读并同意《寻汇营销会员合作协议》与《Sunrate隐私政策》
        text_6: "请先同意并勾选"
      },
      content: { // user.register.content.text_1
        text_1: '发送验证码', // 发送验证码
        text_2: '86', // 86
        text_3: '我已阅读并同意 ', // 我已阅读并同意 《寻汇营销会员合作协议》与《Sunrate隐私政策》
        text_3_1: '《寻汇营销会员合作协议》', // 我已阅读并同意 《寻汇营销会员合作协议》与《Sunrate隐私政策》
        text_3_2: '与', // 我已阅读并同意 《寻汇营销会员合作协议》与《Sunrate隐私政策》
        text_3_3: '《Sunrate隐私政策》', // 我已阅读并同意 《寻汇营销会员合作协议》与《Sunrate隐私政策》
        text_3_4: '我已阅读并同意 《寻汇营销会员合作协议》与《Sunrate隐私政策》', // 我已阅读并同意 《寻汇营销会员合作协议》与《Sunrate隐私政策》
        text_3_5: '我已阅读并同意按照', // 按照《Sunrate隐私政策》将我的个人信息进行跨境传输
        text_3_6: '将我的个人信息进行跨境传输', // 按照《Sunrate隐私政策》将我的个人信息进行跨境传输
        text_4: '已有账户，去登录 >', // 已有账户，去登录 >
        text_5: '立即注册', // 立即注册
        text_6: '重新获取', // 重新获取,Regain
      },
    },
    login: {
      title: { // user.login.title.text_1
        text_1: '寻汇营销会员系统', // 寻汇营销会员系统
        text_2: '手机号登录', // 手机号登录
        text_3: '邮箱登录', // 邮箱登录
      },
      placeholder: { // user.login.placeholder.text_1
        text_1: '邮箱', // 邮箱
        text_2: '手机号', // 邮箱
        text_3: '密码', // 密码
      },
      error: { // user.login.error.text_1
        text_1: '请将滑块拖动至最右侧完成验证', // 请将滑块拖动至最右侧完成验证
        text_2: '用户名不能为空', // 用户名不能为空
        text_3: '请输入密码', // 请输入密码
      },
      content: { // user.login.content.text_1
        text_1: '拖动滑块验证', // 拖动滑块验证
        text_2: '忘记密码?', // 忘记密码?
        text_3_1: '没有账户?', // 没有账户?去注册
        text_3_2: '去注册', // 没有账户?去注册
        text_4: '登录', // 登录
        text_5: '验证通过', // 验证通过
        text_6: '登录成功', // 登录成功
      },
    },
    setting: {
      title: { // user.setting.title.text_1
        text_1: '个人信息', // 个人信息
        text_2: '安全信息', // 安全信息
      },
      form: { // user.setting.form.text_1
        text_1: '账户编号', // 账户编号
        text_2: '原密码', // 原密码
        text_3: '新密码', // 新密码
        text_4: '确认新密码', // 确认新密码
        text_5: '手机号', // 手机号
        text_6: 'E-mail', // E-mail
      },
      placeholder: { // user.setting.placeholder.text_1
        text_1: '请输入原密码', // 请输入原密码
        text_2: '请输入新密码', // 请输入新密码
        text_3: '请确认新密码', // 请确认新密码
      },
      content: { // user.setting.content.text_1
        text_1: '在修改密码之前都需要验证原密码,新密码项不填则不修改密码',
        text_2: '您可以通过手机号或者已验证过的邮箱找回密码',
        text_3: '确认修改',
        completeIdentityThenSignAgreement: "请您在完成身份认证后签署协议",
        downloadSignUploadAgreementAgain: "请下载协议模板，签署盖章后上传扫描件",
        downloadSignUploadClearAgreement: "下载协议《寻汇营销会员合作协议》",
        signedSuccessfully:"签署成功",
        collectionCurrency:"收款币种",

      },
    },
    forgetPassword: {
      title: { // user.forgetPassword.title.text_1
        text_1: '找回密码'
      },
      content: { // user.forgetPassword.content.text_1
        text_1: '恭喜您密码修改成功',
        text_2: '（{timeout}s后返回登录）',
        text_3: '登入平台',
      }
    }
  },
  dashboard: {
    remarkDialog: {
      title: '修改备注',
      placeholder: '请输入备注',
      submitBtn: '提交',
      cancelBtn: '取消',
      validate: {
        remarkRequired: '请输入备注内容'
      }
    },
    step: {
      title: { // dashboard.step.title.text_1
        text_1: '实名认证',
        text_2: '认证审核中',
        text_3: '认证已通过',
        text_4: '认证未通过',
        text_5: '上传协议',
        text_6: '协议审核中',
        text_7: '协议已通过',
        text_8: '协议未通过',
        text_9: '添加银行账户',
        text_10: '银行账户审核中',
        text_11: '银行账户已通过',
        text_12: '银行账户未通过',
        text_13: '注册信息已提交',
        accountRegistration: '账号注册',
        identityVerification: '身份认证',
        signAgreement: '签署协议',
        termsAndPolicies: '条款政策',
        collectionBankAccount: '收款银行账户',
      },
      other: { // dashboard.step.other.text_1
        text_1: '请在完成前置步骤后再进行操作',
      },
      content: { // dashboard.step.content.text_1
        text_1: '恭喜您，您已完成{regType}认证，请完成后续操作', // 恭喜您，您已完成(企业,个人)认证，请完成后续操作
        text_1_2: '企业',
        text_1_3: '个人',
        text_2: '您提交的材料正在审核中，请您耐心等待…', // 您提交的材料正在审核中，请您耐心等待…
        text_3: '由于您的风控评分不达标，我们暂时无法处理。如果有问题请联系客服,谢谢。', // 由于您的风控评分不达标，我们暂时无法处理。如果有问题请联系客服,谢谢。
        text_4: '您提交的材料未通过审核，请及时', // 您提交的材料未通过审核，请及时(去修改)
        text_4_1: '重新认证', // 您提交的材料未通过审核，请及时(去修改)
        text_5: '您尚未完成实名认证,请先', // 您尚未完成实名认证,请先(去认证)
        text_6: '去认证',
        text_7: '恭喜您，您上传的协议已通过，推广链接已生成，请及时添加银行账户', // 恭喜您，您上传的协议已通过，推广链接已生成，请及时添加银行账户
        text_8: '已上传《寻汇营销会员合作协议》', // 已上传《寻汇营销会员合作协议》
        text_9: '先下载《寻汇营销会员合作协议》待盖章后上传清晰、完整的协议', // 先下载《寻汇营销会员合作协议》待盖章后上传清晰、完整的协议
        text_10: '下载《寻汇营销会员合作协议》，请盖章后上传清晰、完整的协议', // 下载《寻汇营销会员合作协议》，请盖章后上传清晰、完整的协议
        text_10_1: '再次上传',
        text_10_2: '驳回原因',
        text_10_3: '点击上传',
        text_11: '银行账户已审核通过', // 银行账户已审核通过
        text_12: '银行账户已添加，我们正在加紧审核中，请您耐心等待，', // 银行账户已添加，我们正在加紧审核中，请您耐心等待，
        text_13: '因涉及后续的收益结算，请添加与您注册名称一致的银行账户，确保信息准确无误', // 因涉及后续的收益结算，请添加与您注册名称一致的银行账户，确保信息准确无误，
        text_15: '去查看>', // 去查看
        text_15_2: '去查看 >', // 去查看
        text_16: '去修改', // 去修改
        text_17: '驳回原因', // 驳回原因
        text_18: '去添加', // 去添加
        text_19: '去添加', // 去添加
        accountRegistrationTip: '账号已注册，请继续完善信息',
        accountRegistrationTip2: '已完成',
        identityVerificationTip: '请完善{regType}身份信息，以便开展业务',
        identityVerificationTip2: '立即认证',
        identityVerificationTipCP: '资料已提交，系统正在加急审核中...',
        identityVerificationTipCP2: '审核中',
        identityVerificationTipRJ: '认证未通过',
        identityVerificationTipRJ3: '重新认证',
        identityVerificationTipCF: '身份认证已通过，请继续签署协议',
        identityVerificationTipCF2: '已完成',
        signAgreementTip: '请下载协议模板，签署盖章后上传扫描件。',
        signAgreementTip2: '下载《寻汇营销会员合作协议》模板',
        signAgreementTip3: '上传文件',
        signAgreementTip4: '《寻汇营销会员合作协议》',
        signAgreementTipCP: '协议文件审核中，预计1个工作日完成。',
        signAgreementTipCP2: '审核中',
        signAgreementTipRJ: '请核对后重新上传。',
        signAgreementTipRJ2: '下载协议《寻汇营销会员合作协议》',
        signAgreementTipRJ3: '重新上传',
        signAgreementTipRJ4: '审核未通过',
        signAgreementTipRJ5: '协议审核未通过，请核对后重新上传。',
      },
    },
    table: { // dashboard.table.text_1
      text_1: '关联客户列表',
      text_2: '客户名称',
      text_3: '客户编号',
      text_4: '账户状态',
      text_5: '结算有效期',
      text_6: '开户日期',
      text_7: '邀请码',
    },
    dialog: {
      title: { // dashboard.dialog.title.text_1
        text_1: '添加收款银行账户', // 添加收款银行账户
        text_2: '收款银行账户', // 收款银行账户
      },
      content: { // dashboard.dialog.content.text_1
        text_1: '1、请添加与您注册名称一致的银行账户并确保信息准确、无误;', // 1、请添加与您注册名称一致的银行账户并确保信息准确、无误;
        text_2: '2、【银行账户类型】请按照实际情况进行填写，企业请选择"企业账户",个人请选择"个人账户";', // 2、【银行账户类型】请按照实际情况进行填写，企业请选择"企业账户",个人请选择"个人账户";
        text_3: '取消', // 取消
        text_4: '确认添加', // 确认添加
        text_5: '我知道了', // 我知道了
        text_6: '暂无数据', // 暂无客户列表
        text_7: '恭喜您认证已通过，您的会员结算有效期为 {start} 至 {end} ', // 恭喜您认证已通过，您的会员结算有效期为 22-9-19 至 22-9-19
        text_8: '今天过期', // 今天过期
        text_9: '{day}天后即将过期', // *天后即将过期
        text_10: '已过期', // 已过期
        text_11: '无开始日期', // 无开始日期
        text_12: '无结束日期', // 无结束日期
        text_13: '未设置', // 未设置
      },
      layout: { // dashboard.dialog.layout.text_1
        text_1: '544px', // 对话框宽度
        text_2: '160px', // 标签宽度
      },
      select: { // dashboard.select.text_1
        text_1: 'cname', // 下拉框显示中文名称
      },
      label: { // dashboard.dialog.label.text_1
        text_1: '地区', // 地区
        text_2: '银行账户类型', // 银行账户类型
        text_3: '账户名称', // 账户名称
        text_4: '币种', // 币种
        text_5: '银行账号', // 银行账号
        text_6: '联系方式', // 联系方式
        text_7: '身份证号码', // 身份证号码
        text_8: '开户行名称', // 开户行名称（精确到支行）
        text_9: '银行开户省市', // 银行开户省市
        text_10: '收款银行账户', // 收款银行账户
        text_11: '审核状态', // 审核状态
        text_12: '收款币种', // 收款币种
        text_13: '联系方式', // 联系方式
      },
      placeholder: { // dashboard.dialog.placeholder.text_1
        text_1: '中国大陆',
        text_2: '中国香港',
        text_3: '新加坡',
        text_4: '企业账户',
        text_5: '个人账户',
        text_6: '请输入账户名称',
        text_7: '请输入银行账号',
        text_8: '请输入联系方式',
        text_9: '请输入身份证号码',
        text_10: '请输入开户行名称（精确到支行）',
        text_11: '请输入银行开户地区',
      }
    },
    share: {
      title: { // dashboard.share.title.text_1
        text_1: '推荐列表', // 推荐链接
        search: "请输入邀请码"
      },
      content: { // dashboard.share.content.text_1
        text_1: '每个会员都拥有唯一的推荐链接，点击下方的复制即可用来推荐他人使用。', // 每个会员都拥有唯一的推荐链接，点击下方的复制即可用来推荐他人使用。
        text_2: '暂未生成链接', // 暂未生成链接
        text_3: '绑定销售', // 绑定销售
        text_4: '全球支付平台推广链接', // 全球支付平台推广链接
      },
    },
    bank: {
      title: { // dashboard.bank.title.text_1
        text_1: '我的银行账户'
      },
      content: { // dashboard.bank.content.text_1
        text_1: '收款账户名称', // 收款账户名称
        text_2: '收款币种', // 收款币种
        text_3: '已通过', // 已通过
        text_4: '已驳回', // 已驳回
        text_5: '审核中', // 审核中
        text_6: '未通过', // 未通过
        text_7: '审核中', // 审核中
        text_8: '待审核', // 待审核
        addBankAcct: '添加银行账户', // 添加银行账户
      },
      error: { // dashboard.bank.error.text_1
        text_1: '请选择账户类型',
        text_2: '请选择收款账户类型',
        text_3: '请填写银行所在省份',
        text_4: '请选择交易币种',
        text_5: '请输入身份证号码',
        text_6: '请输入银行开户地区',
        text_7: '未获取到银行卡信息',
      }
    },
    overview: { // dashboard.overview
      title: '总体概览',
      timeHint: '最近',
      days7: '近7日',
      days30: '近30日',
      days90: '近90日',
      registerCount: '累计注册客户总数',
      openAcctCount: '累计开户客户总数',
      transinUsdAmt: '累计收款折美金额',
      incomeUsdAmt: '累计支付折美金额',
      conversionRate: '开户转化率',
      payTrend: '支付交易趋势',
      transinTrend: '收款交易趋势'
    },
  },
  cascade: {
    transMode: {
      1: {
        1: "第一类 活动物/动物产品",
        2: "第二类 植物产品",
        3: "第三类  动、植物油、脂及其分解产品/精制的食用油脂/动、植物蜡",
        4: "第四类  食品/饮料、酒及醋/烟草、烟草及烟草代用品的制品",
        5: "第五类 矿产品",
        6: "第六类 化学工业及其相关工业的产品",
        7: "第七类  塑料及其制品/橡胶及其制品",
        8: "第八类 生皮、皮革、毛皮及其制品/鞍具及挽具/旅行用品、手提包及类似品/动物肠线（蚕胶丝除外）制品",
        9: "第九类 木及木制品/木炭/软木及软木制品/稻草、秸秆、针茅或其他编结材料制品/篮筐及柳条编结品",
        10: "第十类 木浆及其他纤维状纤维素浆/纸及纸板的废碎品/纸、纸板及其制品",
        11: "第十一类 纺织原料及纺织制品",
        12: "第十二类 鞋、帽、伞、杖、鞭及其零件/已加工的羽毛及其制品/人造花/人发制品",
        13: "第十三类 石料、石膏、水泥、石棉、云母及类似材料的制品/陶瓷产品/玻璃及其制品",
        14: "第十四类 天然或养殖珍珠、宝石或半宝石、贵金属、包贵金属及其制品/仿首饰/硬币",
        15: "第十五类  贱金属及其制品",
        16: "第十六类 机器、机械器具、电气设备及其零件/录音机及放声机、电视图像、声音的录制和重放设备及其零件、附件",
        17: "第十七类  车辆、航空器、船舶及有关运输设备",
        18: "第十八类  光学、照相、电影、计量、检验、医疗或外科用仪器及设备、精密仪器及设备/钟表/乐器/上述物品的零件、附件",
        19: "第十九类 武器、弹药及其零件、附件 ",
        20: "第二十类  杂项制品",
        21: "第二十一类 艺术品、收藏品及古物",
        22: "第二十二类特殊交易品及未分类商品"
      },
      2: {
        1: "第一类 活动物/动物产品",
        2: "第二类 植物产品",
        3: "第三类  动、植物油、脂及其分解产品/精制的食用油脂/动、植物蜡",
        4: "第四类  食品/饮料、酒及醋/烟草、烟草及烟草代用品的制品",
        5: "第五类 矿产品",
        6: "第六类 化学工业及其相关工业的产品",
        7: "第七类  塑料及其制品/橡胶及其制品",
        8: "第八类 生皮、皮革、毛皮及其制品/鞍具及挽具/旅行用品、手提包及类似品/动物肠线（蚕胶丝除外）制品",
        9: "第九类 木及木制品/木炭/软木及软木制品/稻草、秸秆、针茅或其他编结材料制品/篮筐及柳条编结品",
        10: "第十类 木浆及其他纤维状纤维素浆/纸及纸板的废碎品/纸、纸板及其制品",
        11: "第十一类 纺织原料及纺织制品",
        12: "第十二类 鞋、帽、伞、杖、鞭及其零件/已加工的羽毛及其制品/人造花/人发制品",
        13: "第十三类 石料、石膏、水泥、石棉、云母及类似材料的制品/陶瓷产品/玻璃及其制品",
        14: "第十四类 天然或养殖珍珠、宝石或半宝石、贵金属、包贵金属及其制品/仿首饰/硬币",
        15: "第十五类  贱金属及其制品",
        16: "第十六类 机器、机械器具、电气设备及其零件/录音机及放声机、电视图像、声音的录制和重放设备及其零件、附件",
        17: "第十七类  车辆、航空器、船舶及有关运输设备",
        18: "第十八类  光学、照相、电影、计量、检验、医疗或外科用仪器及设备、精密仪器及设备/钟表/乐器/上述物品的零件、附件",
        19: "第十九类 武器、弹药及其零件、附件 ",
        20: "第二十类  杂项制品",
        21: "第二十一类 艺术品、收藏品及古物",
        22: "第二十二类特殊交易品及未分类商品"
      },
      3: {
        1: "服装 / 鞋靴 / 箱包",
        2: "美妆 / 个护健康",
        3: "厨具 / 家居",
        4: "玩具 / 母婴",
        5: "电脑 / 办公文具",
        6: "运动户外",
        7: "手机 / 摄影 / 数码",
        8: "电子配件 / 智能生活",
        9: "食品 / 营养品",
        10: "家电 / 家装 ",
        11: "游戏 / 娱乐乐器",
        12: "钟表 / 首饰",
        99: "其他"
      },
      4: {
        1: "服装 / 鞋靴 / 箱包",
        2: "美妆 / 个护健康",
        3: "厨具 / 家居",
        4: "玩具 / 母婴",
        5: "电脑 / 办公文具",
        6: "运动户外",
        7: "手机 / 摄影 / 数码",
        8: "电子配件 / 智能生活",
        9: "食品 / 营养品",
        10: "家电 / 家装 ",
        11: "游戏 / 娱乐乐器",
        12: "钟表 / 首饰",
        99: "其他"
      },
      5: {
        1: "留学中介",
        2: "海外培训/游学",
        99: "其他"
      },
      6: {
        1: "旅行社/机票代理",
        2: "航空公司",
        3: "OTA",
        99: "其他"
      },
      7: {
        1: "物流",
        2: "广告",
        3: "游戏",
        4: "直播/内容",
        5: "酒店/民宿",
        99: "其他"
      },
      8: {
        1: "境内支付机构",
        2: "境外支付机构"
      }
    }
  },
  dict: {
    annualSales: {
      A: "5万美金以下",
      B: "5万美金-50万美金",
      C: "50万美金-300万美金",
      D: "300万美金-800万美金",
      E: "800万美金以上"
    },
    companyScale: {
      1: "小于20",
      2: "20-50",
      3: "50-100",
      4: "100-300",
      5: "300-1000",
      6: "大于1000"
    },
    transMode: {
      1: "进口B2B",
      2: "出口B2B",
      3: "出口电商",
      4: "进口电商",
      5: "教育",
      6: "航旅",
      7: "服务贸易",
      8: "同业机构"
    },
    tradeOpponent: {
      US: "美国",
      CA: "加拿大",
      GB: "英国",
      EU: "欧元区国家",
      HK: "中国香港",
      SG: "新加坡",
      JP: "日本",
      AU: "澳洲",
      NZ: "新西兰"
    },
    eptMonthAmt: {
      1: "小于10万(USD)",
      2: "10万-30万(USD)",
      3: "30万-50万(USD)",
      4: "50万-1百万(USD)",
      5: "1百万-2百万(USD)",
      6: "2百万-5百万(USD)",
      7: "5百万-1千万(USD)",
      8: "大于1千万(USD)"
    },
    onsite: {
      1: "是",
      0: "否"
    },
    fxTxnStatus: {
      "01": "待确认",
      "02": "已锁汇",
      "03": "已锁汇",
      "04": "出账中",
      "05": "出账中",
      "09": "已出账",
      20: "已取消",
      30: "已作废"
    },
    label: {
      acctId: "Client ID",
      acctName: "Client",
      annualSales: "最近一年月均销售额(USD)",
      companyScale: "公司人数",
      transMode: "业务类型",
      tradeType: "行业&销售产品",
      commodityDesc: "售卖产品描述",
      tradeOpponent: "贸易对手国家",
      transCur: "结算币种",
      eptMonthAmt: "预计月TPV",
      otherInformation: "备注",
      image: "拜访摘要",
      selfCheckFileInfoList: "自查文件",
      title: 'KYC信息补充',
      scoreAuditResult: "审核结果",
      complianceRemark: "审核意见",
    },
    growKycScore: {
      unrated: "未评分",
      excellent: "优秀",
      pass: "合格",
      notPass: "不合格"
    },
    validate: {
      acctName: "请填写Potential名称",
      acctNameRequired: "必填，比如 xxx有限公司或xxx Limited",
      category: "请选择Potential分类",
      source: "请选择Potential来源",
      leadSourceCode: "请选择Potential来源编码",
      typeFlag: "请选择Potential类型",
      importLevel: "请选择Potential级别",
      address: "请填写Potential地址",
      addressRequired: "必填，请填Client办公地址，比如上海市浦东新区福山路370号11楼",
      competingCompany: "请选择Potential竞品",
      contactName: "请填写联系人姓名",
      contactPosition: "请选择联系人职位",
      contactMobile: "请填写联系方式",
      contactMobileRequired: "必填，比如手机号或微信号",
      contactEmail: "请输入联系人邮箱",
      location: "点击获取定位",
      locationRequired: "请先获取定位",
      content: "请先输入内容",
      remark: "如有，请填写其他信息",
      image: "请上传拜访摘要",
      selfCheckFileInfoList: "请上传自查文件",
      searchAcctName: "输入客户名称进行搜索",
      annualSales: "请选择最近一年月均销售额",
      companyScale: "请选择公司人数",
      transMode: "请选择业务类型",
      tradeType: "请选择行业&销售产品",
      commodityDesc: "提供客户具体售卖的商品信息",
      tradeOpponent: "请选择贸易对手国家",
      transCur: "请选择结算币种",
      eptMonthAmt: "请选择预计月TPV",
      otherInformation: "如有，请填其他信息",
      fileVerify: "请选择证件核验",
      fileVerifyInfoList: "请上传证件附件",
      interviewVoucher: "请上传访谈凭证",
      authVoucher: "请上传认证凭证"
    }
  },
  auth: {
    company: {
      register: {
        title: { // auth.company.register.title.text_1
          text_1: '注册人信息'
        },
        label: { // auth.company.register.label.text_1
          text_1: '您的身份',
          text_2: '法定代表人',
          text_3: '授权代表人',
          text_4: '注册人姓名',
          text_5: '授权人姓名',
          text_6: '上传授权书',
          text_7: '证件类型',
          issuingCountry: "证件签发地",
          country: "国家/地区"
        },
        placeholder: { // auth.company.register.placeholder.text_1
          text_1: '请输入注册人姓名',
          text_2: '请输入授权人姓名',
          text_3: '授权书',
          text_4: '人像面',
          text_5: '国徽面',
          text_6: '身份证人像面',
          text_7: '身份证国徽面',
        },
        content: { // auth.company.register.content.text_1
          text_1: '所有材料将不会用于双方业务之外的其他用途，且平台支持您上传有个人水印的材料。',
          text_3: '身份证人像面（照片、文字清晰且边框完整）',
          text_4: '身份证国徽面（文字清晰且边框完整）',
          text_5: '请参照授权书模板上传附件',
          text_5_2: '下载授权书模板>>>',
          text_6: '可接受的文件类型：JPG、JPEG、PNG、BMP、PDF；最大文件大小：5MB',
          text_6_2: '查看示例',
          text_7: '所有材料将不会用于双方业务之外的其他用途，且平台支持您上传有个人水印的材料。',
        },
        error: { // auth.company.register.error.text_1
          text_1: '请上传授权书',
          text_2: '请输入注册人的姓名',
          text_3: '请输入授权人的姓名',
          text_4: '请选择您的身份',
          issuingCountry: '请选择证件签发地',
          issuingCountry2: '请选择国家/地区'
        },
      },
      info: { // auth.company.info.text_1
        title: { // auth.company.info.title.text_1
          text_1: '企业信息'
        },
        label: { // auth.company.info.label.text_1
          text_1: '企业名称',
          text_2: '企业英文名称',
          text_3: '企业注册所在地',
          text_4: '企业经营地址',
          text_5: '企业经营英文地址',
          text_6: '证件类型',
          text_7: '企业注册证书',
        },
        placeholder: { // auth.company.info.placeholder.text_1
          text_1: '请输入企业名称',
          text_2: '请输入企业英文名称',
          text_3: '请输入企业经营地址，需精确到门牌号',
          text_4: '请选择企业注册所在地',
          text_5: '请输入企业经营地址',
          text_6: '请输入企业经营地址英文或者拼音',
        },
        content: { // auth.company.info.content.text_1
          text_1: '董事',
          text_2: '若企业只有英文名称，则此处填写英文名称',
          text_3: '建议填写您的企业英文名称，如无可填写企业名称拼音',
          text_4: '营业执照',
          text_CN: '中国大陆企业请上传最新清楚完整的企业营业执照扫描件，',
          text_TW: '请上传最新清楚完整的企业营业相关执照或者文件扫描件，',
          text_5_1: '印尼企业请上传NIB证书，',
          text_HK: '中国香港企业请上传最新的商业登记证书BR和注册证书CI文件扫描件，',
          text_PK: '商业证件必须在一年内签发。 请上传实益拥有人信息（AoA或其他同等效益文件），',
          text_7: '新加坡企业请上传 ACRA Bizfile 证件，',
          text_8: '文件格式仅支持jpg、jpeg、png、bmp、pdf（请确保上传资料文字清晰可见，最大不超过5MB）',
          text_8_1: ',移动鼠标至上传框可',
          text_9: '商业登记证书BR',
          text_10: '公司注册证书CI',
          text_11: '公司注册证书',
          text_12: '该法定代表人或董事持股比例已超过25%',
          text_13: '添加新董事',
          text_13_2: '添加新监事',
          text_14: '法人',
          text_15: '护照',
          text_15_2: '身份证',
          text_15_3: '人像面',
          text_15_4: '港澳通行证',
          text_15_5: '照片',
          text_16: '上传护照',
          text_17: '需上传护照信息页扫描件，',
          text_17_2: '需上传身份证正反面照片或扫描件，',
          text_17_3: '要求清晰可辩认边角完整。',
          text_18: '删除',
          text_19: '股东',
          text_20: '（ 后续所需证件信息同上，不需重复上传 ）',
          text_21_1: '上传',
          text_21_2: '查看示例',
          text_22: '监事',
          text_23: 'NIB证书',
          text_24: '证件照片',
          upload: "营业执照",
          upload2: "上传企业注册证书",
          uploadBR: "BR",
          uploadBR2: "上传商业登记证书BR",
          uploadCI: "CI",
          uploadCI2: "上传公司注册证书CI",
          uploadCO: "上传实益人信息",
          uploadACRA: "ACRA",
          uploadACRA2: "上传ACRA",
          uploadNib: 'NIB证书',
          uploadNib2: '上传印度尼西亚NIB证书',
          uploadCert: "注册证书",
          uploadCert2: "上传企业注册证书",
          maxFileOther: '请上传最新清楚完整的企业营业相关执照，及实益人信息说明文件（AoA或其他同等效益文件），'
        },
        error: { // auth.company.info.error.text_1
          text_1: '注意：请不要输入全角符号，如：【（。',
          text_2: '请上传证件正面',
          text_3: '请上传证件反面',
          text_4: '请上传企业证书',
          text_5: '请上传企业注册证书',
          text_6: '请上传证件照片',
          upload: "请上传企业注册证书",
          cert: "请上传证书",
          sgCert: "请上传ACRA",
          ACRA: "请上传ACRA证书",
          uploadNib: "请上传印度尼西亚NIB证书",
          otherCert: "请上传企业注册证书",
          maxLength128: "最大长度不能超过128个字符",
        }
      },
      shareholder: { // auth.company.shareholder.text_1
        title: { // auth.company.shareholder.title.text_1
          text_1: '股东信息'
        },
        content: { // auth.company.shareholder.content.text_1
          text_1: '1.您需要提供所有持股25%以上的股东相关信息；',
          text_2: '2.若有多位股东持股超过25%请点击下方的【添加新股东】按钮',
          text_3: '3.如无持股25%以上的股东请填写持股最大的股东信息',
          text_4: '添加新股东',
        }
      },
      business: { // auth.company.business.text_1
        title: { // auth.company.business.title.text_1
          text_1: '业务信息',
          text_2: '业务信息'
        },
        label: { // auth.company.business.label.text_1
          text_1: '您的营业范围简介',
          text_2: '您主要推荐客户类型',
          text_3: '其他材料',
          text_5: '其他材料',
        },
        placeholder: { // auth.company.business.placeholder.text_1
          text_1: '其他材料',
        },
        content: { // auth.company.business.content.text_1
          text_1: '建议填写您的所在行业，具体服务内容，接触的客户类型；例如：我方为深圳知名出口电商培训机构XXXX公司的销售，主要为电商企业提供开店选品培训服务，拥有潜在出口电商客户500家；',
          text_2: '建议填写您主要推荐客户类型，如：跨境电商卖家、出口贸易商等',
          text_3: '上传其他材料',
          text_4: '下一步',
          text_5: '上一步',
          text_6: '文件格式限定为jpg、jpeg、png、bmp、pdf、rar、zip（请确保上传资料文字清晰可见，最大不超过5MB)',
        },
        error: { // auth.company.business.error.text_1
          text_1: '请填写您的营业范围简介',
          text_2: '请填写您主要推荐客户类型',
        }
      },
      overview: { // auth.company.overview.text_1
        title: { // auth.company.overview.title.text_1
          text_1: '信息总览',
          text_2: '实名信息总览',
          text_3: '审核状态',
        },
        content: { // auth.company.overview.content.text_1
          text_1: '去修改',
          text_2: '提交',
          text_3: '驳回原因见下方说明',
          text_4: '返回工作台',
          text_5: '手持身份证人像面照片',
        },
      },
    },
    personal: {
      register: { // auth.personal.register.text_1
        title: { // auth.personal.register.title.text_1
          text_1: '注册人信息',
        },
        label: { // auth.personal.register.label.text_1
          text_1: '用户类型',
          text_1_1: '个人',
          text_2: '真实姓名',
          text_3: '真实姓名（英文）',
          text_4: '证件类型',
          text_5: '常住地址',
          text_6: '常住英文地址',
        },
        placeholder: { // auth.personal.register.placeholder.text_1
          text_1: '请输入真实姓名',
          text_2: '请输入真实姓名（英文）',
          text_3: '证件人像面',
          text_4: '上传国徽面',
          text_5: '手持身份证照片',
          text_6: '请输入常住地址,需精确到门牌号',
        },
        error: { // auth.personal.register.error.text_1
          text_1: '请上传证件正面',
          text_2: '请上传证件反面',
          text_3: '请上传手持身份证人像面照片',
          text_4: '请输入常住地址',
          text_5: '请输入常住地址拼音',
          text_6: '请选择用户类型',
        },
        content: { // auth.personal.register.content.text_1
          text_1: '需上传身份证正反面照片或扫描件，以及手持身份证且五官及身份证清晰的照片，滑动鼠标至上传框可',
          text_1_2: '查看示例',
          text_2: '文件格式限定为jpg、jpeg、png、bmp、pdf、rar、zip（请确保上传资料文字清晰可见，最大不超过5MB)',
          text_3: '身份证人像面（照片、文字清晰且边框完整）',
          text_4: '身份证国徽面（文字清晰且边框完整）',
          text_5: '上传手持身份证人像面照片（建议使用手机后置摄像头进行拍摄，需照片清晰，证件字迹清晰可辨认）',
          text_6: '下一步',
          text_7: '返回更改认证类型',
        },
      },
      business: {
        label: { // auth.company.business.label.text_1
          text_1: '您的营业范围简介',
          text_2: '您主要推荐客户类型',
          text_3: '其他材料',
          text_4: '您的营业范围简介',
          text_5: '其他材料',
        },
      },
      overview: { // auth.company.overview.text_1
        title: { // auth.company.overview.title.text_1
          text_1: '信息总览',
          text_2: '注册人信息总览',
          text_3: '审核状态',
        },
      },
    },
    authType: {
      title: { // auth.authType.title.text_1
        text_1: '企业认证',
        text_2: '个人认证',
      },
      content: { // auth.authType.content.text_1
        text_1: '营业执照影印件',
        text_2: '法人/授权人身份证照影印件',
        text_3: '股份大于25%的股东影印件',
        text_4: '身份证明文件，例如：身份证件、护照等',
        text_5: '手持身份证明文件照片',
      },
      btn: { // auth.authType.btn.text_1
        text_1: '企业实名认证',
        text_2: '个人实名认证',
      }
    },
  },
  client: {
    form: { // client.form.text_1
      text_1: '客户名称',
      text_2: '客户编号',
      text_3: '账户状态',
      text_4: '开户日期',
      text_5: '有效期结束日期',
      text_6: '邀请码',
      text_7: '注册日期',
      submitDate: '提交日期',
    },
    placeholder: { // client.placeholder.text_1
      text_1: '请输入客户名称',
      text_2: '请输入客户编号',
      text_3: '请选择',
      text_4: '开始日期',
      text_5: '结束日期',
      inviteCode: "请输入邀请码",
    },
    table: { // client.table.text_1
      text_1: '客户名称',
      text_2: '客户编号',
      text_3: '账户状态',
      text_4: '结算有效期',
      text_5: '开户日期',
      text_6: '操作',
      text_7: 'KYC信息补充',
    },
    content: { // client.content.text_1
      text_1: '查询',
      text_2: '暂无数据',
      text_3: '使用中',
      text_4: '已注销',
      text_5: '已冻结',
      text_6: '导出',
    },
    accountStatus: {
      text_1: '已激活',
      text_2: '已审核',
      text_3: '已驳回',
      text_4: '未处理',
      text_5: '已分配',
      text_6: '已注销',
      text_7: '重置',
      text_8: '已冻结',
    },
    accountTable: {
      text_1: '店铺名称',
      text_2: '平台',
      text_3: '国家/地区',
      text_4: '币种',
      text_5: '收款账号',
      text_6: '所属银行',
      text_7: '状态',
      text_8: '申请日期',
      text_9: '返回',
      text_10: '收款账号列表',
      text_11: '激活日期',
      text_12: '开户状态',
      text_13: 'KYC状态',
      text_14: '提交日期',
    },
    registerType: {
      label: '注册类型',
      text_1: '个人',
      text_2: '公司',
    },
    registerStatus: {
      text_0: '待处理',
      text_1: '已开户',
      text_2: '处理中',
      text_3: '处理中',
      text_4: '已拒绝',
      text_5: '开户中',
      text_6: '开户中',
      // text_8: '年审中',
      text_R: '驳回待审核',
    },
    stepComplete: {
      label: 'KYC状态',
      text_0: '未提交',
      text_1: '已提交',
    },
  },
  salesSettlement: {
    form: {
      month: '账单月份',
    },
    placeholder: {
      month: '请输入账单月份',
      startMonth: '开始月份',
      endMonth: '结束月份',
    },
    table: {
      text_1: '账单月份',
      text_2: '邀请码',
      text_3: '邀请码备注',
      text_4: '佣金金额',
      text_5: 'TPV',
      text_6: '结算时间',
      text_7: '最近更新时间',
    },
    content: {
      text_1: '查询',
      text_2: '暂无数据',
      text_3: '导出',
      text_4: '邀请码维度业绩结算',
    },
  },
  collection: {
    form: { // collection.form.text_1
      text_1: '客户名称',
      text_2: '入账币种',
      text_3: '入账日期',
    },
    placeholder: { // collection.placeholder.text_1
      text_1: '请选择',
      text_2: '开始日期',
      text_3: '结束日期',
    },
    table: { // collection.table.text_1
      text_1: '客户账号',
      text_2: '客户名称',
      text_3: '收款编号',
      text_4: '入账金额',
      text_5: '入账币种',
      text_6: '入账日期',
      text_7: '手续费',
      text_8: '完成日期',
    },
    content: { // collection.content.text_1
      text_1: '查询',
      text_2: '暂无数据',
    },
    status: {
      pending: '待入账',
      credited: '已入账',
      returning: '退款中',
      returned: '已退款',
    },
    tips: {
      text_1: '提交入账的日期',
      text_2: '最终完成入账的日期',
    }
  },
  settlement: {
    subTitle: '管理您的佣金结算',
    currentMonthTotal: '当月佣金总额',
    confirmBill: '确认账单',
    billMonth: '账单月份',
    amount: '佣金金额',
    settlementStatus: '结算状态',
    settledTime: '结算时间',
    lastUpdateTime: '最新更新时间',
    operation: '操作',
    updatedAt: '更新于',
    settleBill: '确认账单',
    viewBill: '查看',
    underReview: '待结算',
    pending: '结算中',
    settled: '已结算',
    returned: '已退回',
    faceTip: '建议您完成面容采集以更好地完成结算',
    pendingTip: '您的账单已确认，请耐心等待结算',
    notPushedTip: '您的账单尚未生成，请耐心等待',
    settledTip: '请留意您收款账户的到账情况',
    notFaceAuthTip: '未通过人脸认证',
    faceAuthPassedTip: '人脸认证通过',
    notFaceAuthAlert: '您尚未完成人脸认证，请及时认证',
    proceed: '立即认证',
    skip: '暂时跳过',
    tip: '提示',
    billAmount: '账单金额',
    billCycle: '账单周期',
    bankAccount: '收款账号',
    addBankAccount: '新增收款账号',
    selectBankAccount: '请选择收款账号',
    lastUsed: '上次使用',
    invoice: '发票',
    uploadFile: '上传文件',
    notFaceAuthAlertTip: '您尚未完成人脸认证，请及时认证以免影响账单发送',
    noInvoiceTip: '暂无发票文件',
    pleaseUploadInvoice: '请先上传发票',
    accountUnderReview: '您的收款账户状态异常，暂时无法确认账单',
    pleaseSelectAccount: '请选择收款账号',
    invoiceSizeLimit: '发票文件大小不能超过5M',
    maxInvoiceLimit: '最多只能上传20张发票',
    expandDetail: '展开明细',
    collapseDetail: '收起明细',
    totalUploadedInvoices: '共计上传发票数',
    invoiceTotal: '发票总额',
    verified: '已核验',
    notVoided: '未作废',
    voided: '已作废',
    creditAdjusted: '冲红',
    partialCreditAdjusted: '部分冲红',
    fullCreditAdjusted: '全额冲红',
    invoiceDuplicate: '发票重复',
    verificationFailed: '核验失败',
    back: '返回',
    unknownFile: '未知文件',
    totalPrice: '价格合计',
    deductibleAmount: '可抵扣税额',
    invoiceDate: '发票日期',
    invoiceDrawer: '开票人',
    title: '标题',
    sellerName: '销售方名称',
    sellerTaxNumber: '销售方统一社会信用代码',
    purchaseName: '购买方名称',
    purchaseTaxNumber: '购买方统一社会信用代码',
    invoiceNumber: '发票号码',
    pleaseCheck: '请重新上传发票后再确认账单',
    modifySettlementInfo: '修改结算信息',
    settlementDetail: '结算详情',
    faceAuthTitle: '人脸认证',
    chooseVerificationMethod: '您可选择任一方式完成认证',
    method1: '方法一：手机扫码验证（推荐）',
    scanQRCodeTip: '请使用手机扫码并按提示操作',
    method2: '方法二：使用电脑摄像头',
    cameraTip: '请确保电脑已连接摄像头',
    verificationComplete: '我已完成认证',
    startVerification: '立即开始认证',
    cancel: '取消',
    verificationNote1: '请身处光线充足的环境，摘除口罩、墨镜或遮挡物。',
    verificationNote2: '请勿关闭此弹框；若使用 iOS 设备扫码，请通过 Safari 浏览器打开链接。',
    toConfirm: '尚未完成认证，请确认！'
  },
  trade: {
    form: { // trade.form.text_1
      text_1: '客户名称',
      text_2: '交易日期',
      text_3: '交易完成日期',
      text_4: '交易币种',
    },
    placeholder: { // trade.placeholder.text_1
      text_1: '请选择',
      text_2: '开始日期',
      text_3: '结束日期',
    },
    table: { // trade.table.text_1
      text_1: '客户账号',
      text_2: '客户名称',
      text_3: '买入金额',
      text_4: '买入币种',
      text_5: '卖出金额',
      text_6: '卖出币种',
      text_7: '交易日期',
      text_8: '交易完成日期',
      text_9: '手续费',
      text_10: '交易编号',
      text_11: '收款账号',
      text_12: '状态',
    },
    status: {
      lockedRate: '已锁汇',
      processing: '出账中',
      sent: '已出账'
    },
    tips: {
      text_1: '提交交易的日期',
      text_2: '交易最终交割完成的日期',
    }
  },
  serverSide: {
    errorEnum: { // serverSide.errorEnum.SYS0001
      /* eslint-disable */
      '500': '服务不可用',
      /* eslint-enable */
      SYS0001: '网络错误',
      SYS0002: '参数错误',
      SYS0003: '文件导出异常',
      COM0001: '新增失败',
      COM0002: '修改失败',
      COM0003: '查询失败',
      COM0004: '注册失败',
      COM0005: '提交失败',
      COM0006: '审核失败',
      WJ0003: '文件编码失败',
      WJS0004: '文件解码失败',
      WJ0005: '目录创建失败',
      WJ0006: '目录读取失败',
      AT2010: '登录失败操作太过频繁，请稍后再试',
      AT2011: '登录失败',
      AT2012: '用户不存在或已无效',
      AT2013: '当前手机号已经注册多个账号，请使用邮箱操作',
      AT2014: '不能通过该手机号码重置密码',
      AT2015: '令牌已失效',
      AT2016: '没有权限访问',
      AT2021: '短信验证码不匹配',
      AT2022: '发送短信验证码失败',
      AT2023: '发送短信验证码过于频繁',
      AT2024: '请先发送短信验证码',
      AT2025: '邮箱验证码不匹配',
      AT2026: '手机验证码已失效',
      AT2027: '邮箱验证码已失效',
      AT2028: '邮件发送失败',
      AT2029: '抱歉，您的账户已失效，请联系客户经理',
      AT2050: "密码必须包含特殊字符(!{'@'}#)",
      AT2051: '密码长度为8到16位',
      AT2052: '密码只能包含大小写字符,数字',
      AT2053: '密码必须包含数字',
      AT2054: '验证码校验失败次数过多,请重新获取',
      AT2055: '您的账号在其他地方登录,当前登录已失效',
      AT2056: '发送邮箱验证码过于频繁',
      AT2057: '原密码错误',
      AT2058: '发送审核结果短信失败',
      AT2059: '发送钉钉信息失败',
      AT30001: '请上传证件和授权书',
      AT3002: '保存文件失败',
      AT3003: '请上传证件信息',
      AT3004: '注册信息不存在',
      AT3005: '只有待审核和已驳回才允许修改',
      AT3006: '文件不存在',
      AT3007: '常住英文地址不能为中文',
      AT3008: '只有未提交和已驳回才允许更改注册类型',
      AT3009: '更改注册类型失败',
      AT3010: '注册信息为空，请先新增注册信息',
      AT3011: '接口调用错误',
      AT3012: '还有信息未填写，请填写后再提交',
      AT3013: '还有信息未审核，请审核后再提交',
      AT3014: '请先填写企业信息',
      AT3015: '请先填写注册人信息',
      AT3016: '请审核通过后再操作',
      AT3017: '起始日期必须小于结束日期',
      AT3018: '审核中和已通过不允许修改',
      AT4001: '收款账户不存在',
      AT4002: '收款账户状态有误',
      AT5001: '该平台信息已发布，不允许修改',
      AT5002: '数据已过期，请刷新重试',
      AT5003: '只有草稿状态才可以发布',
      AT5004: '只有发布状态才可以下架',
      AT5005: '还未填写客户端须填写信息模板，请填写完在发布',
      AT5006: '只有审核中的客户信息才允许审核',
      AT5007: '驳回请填写驳回原因',
      '000000': '操作成功',
      GW0402: '认证异常，检查acctId是否正确',
      GW0300: '认证信息失效',
      GW0301: '您的账号在其他地方登录,当前登录已失效',
      GW0900: '请求对象为空',
      GW0903: '响应为空',
      GW0904: '请求报文错误，无法解析',
      GW0905: '加签或加密异常',
      GW0907: '无对应的算法',
      GW0908: '无效的公钥',
      GW0909: '明文有误',
      GW0911: '解密失败',
      GW0912: '请求报文为空',
      GW0915: '系统资源已存在不可重复',
      GW0910: '空指针异常',
      GW0302: 'cookie中的token为空',
      GW0504: '系统无对应数据库配置',
      GW0505: '初始化AppId对应系统，数据库连接异常',
      GW0001: '请求报文已过时',
      GW0404: '请求资源不存在',
      GW0403: '鉴权认证异常',
      GW0401: '认证异常，检查appId是否正确',
      GW0400: '参数格式错误',
      GW0901: '远程响应验签异常',
      GW0902: '第三方url为空',
      GW0906: '报文解析异常或解密异常',
      GW0914: '商户信息不存在',
      GW0999: '',
      GW0501: '服务异常',
      GW0502: '无可用的验签服务',
      GW0506: '验签失败',
      GW0503: '无对应的鉴权服务',
      GW0500: '服务不可用',
      AT5029: '发票不符合要求，请重新确认后提交',
      AT5030: '请确保发票金额与账单金额匹配',
      AT5031: "此发票今日查询次数已达上限,请次日查询"
    },
    customError: { // serverSide.customError.text_1
      text_1: '登录已过期，请重新登录',
      text_2: '您的账号未登录，请先登录',
      text_3: '后端接口({code})异常',
    }
  },
  component: {
    zoneNumber: {
      "enter": "请输入国家/地区名称或区号",
      "noData": "没有符合条件的数据"
    }
  }
}
